var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendeeUploads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 1.66666H3.33301V18.3333H16.6663V6.66666L11.6663 1.66666ZM10.833 12.5V15.8333H9.16634V12.5H6.66634L10.008 9.16666L13.333 12.5H10.833ZM10.833 7.5V2.91666L15.4163 7.5H10.833Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeeUploads);
export default __webpack_public_path__ + "static/media/attendee-uploads.6d962df8e04af35e48e78cc27689028c.svg";
export { ForwardRef as ReactComponent };